import Vue from 'vue'
import Router from 'vue-router'

import login from '@/views/login'
import index from '@/views/index'
import statistics from '@/views/charts/statistics'
import banner from '@/views/home/banner'
import featured from '@/views/home/featured'
import policies from '@/views/home/policies'
import user from '@/views/system/user'
import anchors from '@/views/anchor/index'
import businessApplications from '@/views/applications/business/index'
import businessApplicationDetail from '@/views/applications/business/detail'
import evaluationApplications from '@/views/applications/evaluation/index'
import evaluationApplicationDetail from '@/views/applications/evaluation/detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: login,
      hidden: true,
      meta: { requireAuth: false }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: { requireAuth: false }
    },
    {
      path: '/admin',
      component: index,
      meta: { requireAuth: true },
      children: [
        { path: '/dashboard', name: '数据看板', component: statistics, meta: { requireAuth: true } },
        { path: '/home/banner', name: 'Banner管理', component: banner, meta: { requireAuth: true } },
        { path: '/home/featured', name: '推荐主播管理', component: featured, meta: { requireAuth: true } },
        { path: '/home/policies', name: '扶持政策管理', component: policies, meta: { requireAuth: true } },
        { path: '/system/user', name: '用户管理', component: user, meta: { requireAuth: true } },
        { path: '/anchors', name: '主播管理', component: anchors, meta: { requireAuth: true } },
        { path: '/applications', redirect: '/applications/business', meta: { requireAuth: true } },
        { path: '/applications/business', name: '商业合作申请', component: businessApplications, meta: { requireAuth: true } },
        { path: '/applications/business/:id', name: '商业合作申请详情', component: businessApplicationDetail, meta: { requireAuth: true } },
        { path: '/applications/evaluation', name: '资产评估申请', component: evaluationApplications, meta: { requireAuth: true } },
        { path: '/applications/evaluation/:id', name: '资产评估申请详情', component: evaluationApplicationDetail, meta: { requireAuth: true } }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js